import React from 'react';
import {UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import PremiumCheckbox from 'shared/ui/Checkbox/PremiumCheckbox/PremiumCheckbox';

import FieldCard from '../FieldCard/FieldCard';
import {getBodyMethodHint, getScreenshotOnErrorHint} from '../checkboxBlockHints';

import styles from '../CheckboxBlock.module.scss';

interface IScreenshotFieldProps {
    register: UseFormRegister<any>,
    selective: boolean,
    freeTariff: boolean,
    enabled: boolean,
    bodyMethodDisabled: boolean,
    onCheckboxClick: () => void,
    onRemove?: () => void,
}

const ScreenshotField: React.FC<IScreenshotFieldProps> = ({
    register,
    selective,
    freeTariff,
    enabled,
    bodyMethodDisabled,
    onCheckboxClick,
    onRemove,
}) => (
    <FieldCard selective={selective} freeTariff={freeTariff} onRemove={onRemove}>
        <div onClick={onCheckboxClick}>
            <PremiumCheckbox
                label={t`Скриншот страницы ошибки`}
                helpText={getScreenshotOnErrorHint()}
                register={register('screenshot_on_error')}
                enabled={enabled}
                disabled={bodyMethodDisabled}
            />
        </div>

        {bodyMethodDisabled && (
            <p className={styles.methodHint}>{getBodyMethodHint()}</p>
        )}
    </FieldCard>
);

export default ScreenshotField;
